var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"c-slide-control-next",attrs:{"color":"transparent","flat":"","ripple":""},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_c('v-btn',{attrs:{"fab":"","depressed":"","small":"","color":"grey lighten-2"}},[_c('v-icon',[_vm._v("mdi-chevron-right")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }